import { useAuthContext } from "@/contexts/AuthContext";
import { ROLE_PERMISSIONS } from "@/types/rbac";
import type { Permission, AppSlug } from "@/types/rbac";

export function useRBAC() {
  const { profile, orgApps } = useAuthContext();

  function can(permission: Permission): boolean {
    if (!profile) return false;
    const permissions = ROLE_PERMISSIONS[profile.role] ?? [];
    return permissions.includes(permission);
  }

  function hasApp(appSlug: AppSlug): boolean {
    return orgApps.includes(appSlug);
  }

  function isRole(...roles: string[]): boolean {
    if (!profile) return false;
    return roles.includes(profile.role);
  }

  return { can, hasApp, isRole, role: profile?.role ?? null };
}
